import {
  DashboardPanelType,
  DashboardSortByTimeType,
  OpenDataTokenResult,
} from "@hooks/types";

export type BaseColumnProps = {
  record: OpenDataTokenResult;
  index?: number;
  panelType?: DashboardPanelType;
  sortBy?: DashboardSortByTimeType;
  fontColor?: string;
  hideOnMobile?: boolean;
  className?: string; // 支持外部传入自定义类名
};

export const zeroReturn = "--";
